import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ACTIVE_CLIENT_FEATURE_KEY } from './active-client.selectors';

export const activeClientActions = createActionGroup({
  source: ACTIVE_CLIENT_FEATURE_KEY,
  events: {
    'Set active client': props<{ clientCode: string }>(),
    Hydrate: emptyProps(),
  },
});
